
<div [formGroup]="orderForm" class="full-width"  >

  <button mat-raised-button color="primary" (click)="addParameter()">Criar um novo parametro</button>


  <div formArrayName="items" *ngFor="let item of _items.controls; let i = index;">
    <div [formGroupName]="i">

      <mat-card class="full-width" >
        <div class="row">

          <div class="col-md-1 ">
            <mat-form-field>
              <input matInput formControlName="index" placeholder="Faixa">
            </mat-form-field>
          </div>

        <div class="col-md-2 ">
          <mat-form-field>
            <input matInput formControlName="description" placeholder="Nome do Parametro">
          </mat-form-field>
        </div>

        <div class="col-md-2">
          <mat-form-field>
            <number-list placeholder="Premiações" formControlName="awards" [isTextArea]="false"></number-list>
          </mat-form-field>
        </div>



        <div class="col-md-2 ">
          <mat-form-field>
            <number-list placeholder="Premiações Coringas" formControlName="jockerAwards" [isTextArea]="false"></number-list>
          </mat-form-field>
        </div>

        <div class="col-md-2 full-width">
          <mat-form-field>
            <input matInput type="number" placeholder="Quantidade sorteada" formControlName="amountDrawn">
          </mat-form-field>
        </div>

        <div class="col-md-2 full-width">
          <mat-form-field>
            <input matInput type="number" placeholder="Quantidade sorteada de Coringas"
              formControlName="jockerAmountDrawn">
          </mat-form-field>
        </div>


        <div class="col-md-1">
          <button mat-icon-button color="primary" (click)="remove(i)" aria-label="Remover">
            <mat-icon>remove_circle</mat-icon>
          </button>
        </div>
        
        </div>
        <div class="row">
          <div class="col-md-12 full-width">
            <span>Definição de niveis de premiação</span>
          
            <mat-form-field class="full-width">
            <award-level-params formControlName="awardLevelParams"></award-level-params>
            </mat-form-field>
          </div>
        </div>
      </mat-card>
      <br>
    </div>

  </div>

  </div>
